import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class TrainersGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Trainers',
            ROUTE_PATH.trainersGrid,
            ROUTE_PATH.trainersAdd,
            true,
            false,
            8,
            false,
            true,
            ['name'],
            false,
            [],
            {
                isDownloadExcel: false, excelFileName: '',
                btnLabel: '', headers: []
            },
            false,
            {},
            false,
            false,
            false,
            null,
            { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: true }
           
        );
    }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const trainerName = new Headers(
      'Trainer name',
      'name',
      false,
      true,
      'text',
      '0',
      { isColumnNavigation: true, navigationUrl: ROUTE_PATH.viewTrainers, navigateOperationType: OperationType.VIEW, navigateTransferData: new GridParams() }
    );
    const trainerEmail = new Headers('Email ID', 'email', false, true, 'text');
    const Category = new Headers(
      'Category',
      'category_name',
      false,
      true,
      'text',
     
    );
    const mobile_number = new Headers(
      'Mobile Number',
      'mobile_number',
      false,
      true,
      'text'
    );
    const status = new Headers('Status', 'status', false, false, 'toggle');
    headers.push(trainerName);
    headers.push(trainerEmail);
    headers.push(Category);
    headers.push(mobile_number);
    headers.push(status);

    return headers;
  }



}